import slug from 'slug'

export function useAnchorTitle(title) {
  const value = typeof title === 'string' ? title : (title?.value ?? '')
  if (value === '') {
    return ''
  }
  try {
    return slug(value, { lower: true, trim: true, strict: true })
  }
  catch (err) {
    console.error(err)
    return ''
  }
}
